import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Esto es para principiantes o necesito experiencia previa?',
    answer: 'No necesitás experiencia. Está pensado para empezar desde cero con explicaciones claras y paso a paso.'
  }, {
    question: '¿Y si ya intenté aprender crochet y no me salió?',
    answer: 'Este método es para vos. El problema no eras vos, sino cómo te lo explicaban.'
  }, {
    question: '¿En qué formato está el ebook y cómo lo recibo?',
    answer: 'Es digital (PDF). Lo recibís al instante y podés verlo desde cualquier dispositivo.'
  }, {
    question: '¿Cuánto tiempo me va a llevar ver resultados?',
    answer: 'Desde el primer día podés empezar. Muchas alumnas logran resultados en pocos días.'
  }, {
    question: '¿Incluye ideas que realmente se puedan vender?',
    answer: 'Sí. Incluye diseños pensados para generar ingresos desde casa.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tenés 7 días de garantía. Te devolvemos el 100% del dinero.'
  }, {
    question: '¿Necesito materiales costosos?',
    answer: 'No. Podés empezar con materiales básicos y accesibles.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-24 px-4 bg-cream" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <h2 className="font-heading font-bold text-3xl md:text-5xl text-center text-textDark mb-16" data-id="element-43">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-secondary/50 transition-all duration-300 hover:shadow-soft" data-id="element-45">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 md:p-8 text-left transition-colors" aria-expanded={openIndex === index} data-id="element-46">
                <h3 className="font-heading font-bold text-lg md:text-xl text-textDark pr-4" data-id="element-47">
                  {faq.question}
                </h3>
                <div className={`p-2 rounded-full bg-secondary/30 transition-transform duration-300 ${openIndex === index ? 'rotate-180 bg-primary/10' : ''}`} data-id="element-48">
                  <ChevronDownIcon className={`w-5 h-5 ${openIndex === index ? 'text-primary' : 'text-textLight'}`} aria-hidden="true" data-id="element-49" />
                </div>
              </button>

              <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openIndex === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-50">
                <div className="px-6 md:px-8 pb-6 md:pb-8 pt-0" data-id="element-51">
                  <p className="font-body text-lg text-textLight leading-relaxed border-t border-secondary/30 pt-4" data-id="element-52">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}